import { useEffect, useRef, useState } from 'react'
import type { BoardState } from './board'
import { emptyAnimationView, WhiteboardAnimator } from './whiteboardAnimation'

export function useWhiteboardAnimation(board: BoardState, enabled: boolean, onCommit: (board: BoardState) => void) {
  const [view, setView] = useState(emptyAnimationView)
  const commit = useRef(onCommit)
  commit.current = onCommit
  const [animator] = useState(() => new WhiteboardAnimator(board,setView,next => commit.current(next)))
  useEffect(() => { animator.sync(board,enabled) }, [animator,board,enabled])
  useEffect(() => {
    const visibility = () => animator.setHidden(document.hidden)
    visibility()
    document.addEventListener('visibilitychange',visibility)
    return () => { document.removeEventListener('visibilitychange',visibility); animator.dispose() }
  }, [animator])
  return { ...view, animator }
}
